import { PlpContextProvider } from '@ldp/sdm-contexts';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { css, Global } from '@emotion/react';
import { PortalDrawer } from '@ldp-web/component-library/ui/atoms/drawer';
import { FilterSkeleton } from '../../skeletons';

const PlpContextWrapper = ({ children }: { children: React.ReactNode }) => {
  const [shouldShowDrawer, setShouldShowDrawer] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const onDrawerClose = useCallback(() => {
    setShouldShowDrawer(false);
  }, [setShouldShowDrawer]);

  return isClient ? (
    <PlpContextProvider
      shouldShowDrawer={shouldShowDrawer}
      setShouldShowDrawer={setShouldShowDrawer}
      drawerRef={containerRef}
    >
      {children}
      <Global
        styles={css`
          .rc-drawer-mask {
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            position: absolute;
            width: 100%;
            z-index: 1050;
            background: rgba(0, 0, 0, 0.5);
            pointer-events: auto;
          }

          .rc-drawer-content-wrapper {
            position: absolute;
            z-index: 1050;
          }

          .rc-drawer-left .rc-drawer-content-wrapper {
            top: 0;
            bottom: 0;
            left: 0;
          }

          .rc-drawer-right .rc-drawer-content-wrapper {
            top: 0;
            right: 0;
            bottom: 0;
          }

          @media (max-width: 25.875em) {
            .rc-drawer-content-wrapper {
              width: 100% !important;
            }
          }

          .rc-drawer-content {
            background: #ffffff;
            width: 100%;
            height: 100%;
          }
        `}
      />
      <PortalDrawer open={shouldShowDrawer} onClose={onDrawerClose} ref={containerRef} forceRender placement="right">
        {shouldShowDrawer && <FilterSkeleton />}
      </PortalDrawer>
    </PlpContextProvider>
  ) : (
    children
  );
};

PlpContextWrapper.displayName = 'PlpContextWrapper';

export default PlpContextWrapper;
